import { GRAFTCODE_ONBOARDING_ASSETS_BASE, type GraftcodeOnboardingScenarioId } from './graftcode-onboarding.const'

export type OnboardingTutorialVideo = {
  youtubeId: string
  embedUrl: string
}

const embed = (youtubeId: string) => `https://www.youtube-nocookie.com/embed/${youtubeId}`

export type OnboardingYoutubeEmbedOptions = {
  autoplay?: boolean
  controls?: boolean
}

export function buildOnboardingYoutubeEmbedSrc(
  embedUrl: string,
  { autoplay = false, controls = true }: OnboardingYoutubeEmbedOptions = {}
): string {
  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
    controls: controls ? '1' : '0',
  })
  if (autoplay) {
    params.set('autoplay', '1')
  }
  return `${embedUrl}?${params.toString()}`
}

/** Fallback when stack frontmatter omits `video:`. */
export const GRAFTCODE_ONBOARDING_SCENARIO_VIDEOS: Record<GraftcodeOnboardingScenarioId, OnboardingTutorialVideo> = {
  frontend: { youtubeId: '4STJGCDi4i0', embedUrl: embed('4STJGCDi4i0') },
  backend: { youtubeId: 'uJaVGO6yiwU', embedUrl: embed('uJaVGO6yiwU') },
  mcp: { youtubeId: 'CIEnRBhGjWo', embedUrl: embed('CIEnRBhGjWo') },
  microservices: { youtubeId: 'hI-5b0xyiLk', embedUrl: embed('hI-5b0xyiLk') },
  modules: { youtubeId: 'loB582GaY_E', embedUrl: embed('loB582GaY_E') },
  monolith: { youtubeId: '0ZGluAFzLT4', embedUrl: embed('0ZGluAFzLT4') },
}

export function youtubeThumbnailUrl(youtubeId: string): string {
  return `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`
}

/** Marketing / Academy embeds on the post-tutorial dashboard (not scenario markdown). */
export type GraftcodeOnboardingDashboardVideo = {
  id: string
  title: string
  titleKey?: string
  thumbSrc: string
  embedSrc: string
}

const dashboardThumb = (file: string) => `${GRAFTCODE_ONBOARDING_ASSETS_BASE}/dashboard/thumbs/${file}`

export const GRAFTCODE_ONBOARDING_DASHBOARD_VIDEOS: GraftcodeOnboardingDashboardVideo[] = [
  {
    id: 'action',
    title: 'Graftcode in action',
    titleKey: 'postTutorial.videos.action',
    thumbSrc: dashboardThumb('action.jpg'),
    embedSrc: 'https://share.descript.com/embed/xDrYh06ZJfd',
  },
  {
    id: 'react-backend',
    title: 'Connect React to backend',
    titleKey: 'postTutorial.videos.reactBackend',
    thumbSrc: dashboardThumb('react.jpg'),
    embedSrc: 'https://www.youtube-nocookie.com/embed/4STJGCDi4i0?rel=0&modestbranding=1&playsinline=1',
  },
  {
    id: 'javascript-backend',
    title: 'Expose a JavaScript backend',
    titleKey: 'postTutorial.videos.javascriptBackend',
    thumbSrc: dashboardThumb('javascript.jpg'),
    embedSrc: 'https://www.youtube-nocookie.com/embed/uJaVGO6yiwU?rel=0&modestbranding=1&playsinline=1',
  },
  {
    id: 'mcp',
    title: 'Expose MCP for AI',
    titleKey: 'postTutorial.videos.mcp',
    thumbSrc: dashboardThumb('mcp.jpg'),
    embedSrc: 'https://www.youtube-nocookie.com/embed/CIEnRBhGjWo?rel=0&modestbranding=1&playsinline=1',
  },
]
